import { connect } from 'react-redux'
import {
  finalizeGarminIntegration,
  initializeGarminIntegration,
  setIntegration,
} from '../../common/integration/integrationActions'
import { IDispatchProps, IntegrationProxy } from './IntegrationProxy'

const mapStateToProps = () => ({})

const mapDispatchToProps: IDispatchProps = {
  setIntegration,
  initializeGarminIntegration,
  finalizeGarminIntegration,
}

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationProxy)
